import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取导购列表
   */
  getEmployeeList(pageSize: number, currentPage: number, IsActive?: boolean, Filter?: string, Department?: string[]) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      IsActive,
      Filter,
      Department
    }
    return Ajax.get(`/api/Vip/Employee`, {
      params: params
    })
  },

  /**
   * 设置导购是否离职
   */
  leaveOffice(id: string, dateOfDeparture?: string) {
    return Ajax.post(`/api/Vip/Employee/LeaveOffice`, {
      id,
      dateOfDeparture
    })
  },

  /**
 * 删除导购信息
 */
  deleteEmployee(id: string) {
    return Ajax.delete(`/api/Vip/Employee?id=${id}`)
  },
  /**
 * 删除导购信息
 */
  deleteVipInfos(id: string) {
    return Ajax.delete(`/api/Vip/VipInfos?id=${id}`)
  },

  /**
   * 获取导购详细信息
   * @param id 
   */
  getEmployee(id: string) {
    return Ajax.get(`/api/Vip/Employee/${id}`)
  },

  /**
   * 创建/更新导购信息
   */
  createOrUpdateEmployee(obj: object) {
    let ajaxType = obj['id'] ? 'put' : 'post'
    return Ajax[ajaxType](`/api/Vip/Employee`, obj)
  },

  /**
  * 查询专属会员
  * @param id 
  */
  getVipInfoList(GuideId: string, pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      GuideId
    }
    return Ajax.get(`/api/Vip/Employee/VipInfoList`, {
      params: params
    })
  },

  /**
   * 获取指定导购的收益明细
   */
  employeeEarning(GuideId: string, pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      GuideId
    }
    return Ajax.get(`/api/Vip/EmployeeEarning`, {
      params: params
    })
  },

  /**
   * 获取导购分享列表
   * @param pageSize 
   * @param currentPage 
   * @param IsActive 
   * @param Filter 
   */
  getProductMatchList(pageSize: number, currentPage: number, IsActive?: boolean, Filter?: string) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      IsActive,
      Filter
    }
    return Ajax.get(`/api/Article/ProductMatch`, {
      params: params
    })
  },

  /**
   * 批量修改导购分享是否启用
   * @param ids 
   * @param isActive 
   */
  isActiveProductMatch(ids: string[], isActive: boolean) {
    return Ajax.put(`/api/Article/ProductMatch`, {
      ids,
      isActive
    })
  },

  /**
   * 获取指定导购分享
   * @param id 
   */
  getProductMatch(id: string) {
    return Ajax.get(`/api/Article/ProductMatch/${id}`)
  },

  /**
   * 获取分销收益月汇总
   */
  getMonthStatics(month: string, type?: number, userIds?: string[]) {
    return Ajax.post(`/api/distribution/distributionOrder/MonthStatics`, {
      month,
      type,
      userIds
    })
  },

  /**
   * 根据门店Id列表查询导购id列表
   */
  getEmployeeIdByShopId(id: string[]) {
    return Ajax.post(`/api/Vip/Employee/GetEmployeeIdByShopId`, {
      id
    })
  }
}